import {useIntl} from 'react-intl'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const MESSAGE_REGEX = /^[A-Za-z0-9\s.,!?'"()-]*$/
const MAX_MESSAGE_LENGTH = 200

const {
    app: {commerceAPI}
} = getConfig()

const {eGiftCards} = commerceAPI.storefront || {}

let RESTRICTED_WORDS = []

try {
    const parsed = JSON.parse(eGiftCards || '{}')
    const words = parsed.restrictedWords
    RESTRICTED_WORDS = Array.isArray(words) ? words.map((w) => String(w).trim()) : []
} catch (err) {
    console.warn('Failed to parse restrictedWords for gift wrap:', err)
    RESTRICTED_WORDS = []
}

export default function useGiftWrapFields({
    form: {
        control,
        setValue,
        formState: {errors}
    },
    setShipmentGift,
    shipment,
    isCheckout,
    setCharactersRemaining
}) {
    const {formatMessage} = useIntl()

    const fields = {
        giftWrapCheckBox: {
            name: 'giftWrapCheckBox',
            label: formatMessage({
                defaultMessage: 'Add a complimentary gift box',
                id: 'use_giftwrap_fields.label.checkbox'
            }),
            defaultValue: shipment?.gift || false,
            type: 'checkbox',
            error: errors?.giftWrapCheckBox,
            inputProps: isCheckout
                ? ''
                : ({onChange}) => ({
                      onChange(evt) {
                          onChange(evt.target.checked)
                          setShipmentGift({giftWrapCheckBox: evt.target.checked})
                      }
                  }),
            control
        },
        giftWrapMessage: {
            name: 'giftWrapMessage',
            label: formatMessage({
                defaultMessage: 'Gift Message (Optional)',
                id: 'use_giftwrap_fields.label.message'
            }),
            defaultValue: shipment?.giftMessage || '',
            type: 'textarea',
            error: errors?.giftWrapMessage,
            control,
            inputProps: ({onChange}) => ({
                maxLength: MAX_MESSAGE_LENGTH,
                onChange(evt) {
                    const raw = evt.target.value
                    const clamped = raw.slice(0, MAX_MESSAGE_LENGTH)
                    onChange(clamped)
                    if (setValue) {
                        setValue('giftWrapMessage', clamped, {shouldValidate: true})
                    }
                    if (setCharactersRemaining) {
                        setCharactersRemaining(MAX_MESSAGE_LENGTH - clamped.length)
                    }
                }
            }),
            rules: {
                validate: (value) => {
                    const v = value || ''
                    if (!v) return true

                    if (!MESSAGE_REGEX.test(v)) {
                        return formatMessage({
                            id: 'giftwrap.message.invalid_characters',
                            defaultMessage: 'Emojis and special characters are not permitted.'
                        })
                    }

                    const lower = v.toLowerCase()
                    const words = lower.split(/[\s.,!?;:()"'[\]{}<>/\\|-]+/)
                    if (
                        RESTRICTED_WORDS.length > 0 &&
                        RESTRICTED_WORDS.some((bad) => words.includes(bad.toLowerCase()))
                    ) {
                        return formatMessage({
                            id: 'giftwrap.message.restricted_word',
                            defaultMessage:
                                'Your message contains a word that is not allowed. Please revise.'
                        })
                    }

                    return true
                }
            }
        }
    }
    return fields
}
